import React, { createContext, useContext, useState, useEffect } from "react";
import { FirebaseContext } from "./FirebaseContext";

export const AuthContext = createContext<any>({});

interface FlashMessageProp {
  show: boolean;
  style: string;
  msg: string;
}

const AuthProvider: React.FC<{ children: any }> = ({ children }) => {
  const firebase = useContext(FirebaseContext);

  const [isAuth, setAuth] = useState<boolean>(false);
  const [currentUser, setCurrentUser] = useState({});
  const [flashMessage, setFlashMessage] = useState<FlashMessageProp>({
    show: false,
    style: "",
    msg: "",
  });

  console.log("isAuth", isAuth);

  console.log(currentUser);
  useEffect(() => {
    firebase.authentication().onAuthStateChanged((firebaseUser: object) => {
      if (firebaseUser) {
        console.log(firebaseUser);
        setCurrentUser(firebaseUser);
        setAuth(true);
      } else {
        console.log("error");
        setCurrentUser({});
        setAuth(false);
      }
    });

    if (flashMessage.show) {
      setTimeout(() => {
        setFlashMessage({
          show: false,
          style: "",
          msg: "",
        });
      }, 2000);
    }
  }, [firebase, flashMessage.show]);

  return (
    <AuthContext.Provider
      value={[currentUser, flashMessage, setFlashMessage, isAuth, setAuth]}
    >
      {children}
    </AuthContext.Provider>
  );
};
export default AuthProvider;
